// extracted by mini-css-extract-plugin
module.exports = {"rawBank":"RawBank_rawBank__OfZA_","button":"RawBank_button__sAIk3","banked":"RawBank_banked__jfC3_","note":"RawBank_note__SOJC5","error":"RawBank_error__Eqrvh"};